<!--title-->
<h2 mat-dialog-title>
  <i class="material-icons m-r-10">supervisor_account</i>
  <span>{{'Modules.Shared.Users.Selector.Title' | translate}}</span>
</h2>

<!--content-->
<mat-dialog-content>

  <!--filters-->
  <div class="pc-form-filters">
    <form [formGroup]="_searchForm" (ngSubmit)="search()">
      <div class="row">
        <div class="col-lg-4">
          <mat-form-field>
            <mat-label>{{'Modules.Users.Applications.Users.List.SearchForm.Name' | translate}}:</mat-label>
            <input type="text" matInput formControlName="name" />
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field>
            <mat-label>{{'Modules.Users.Applications.Users.List.SearchForm.Email' | translate}}:</mat-label>
            <input type="text" matInput formControlName="email" />
          </mat-form-field>
        </div>
        <div class="col-lg-2">
          <div class="buttons-group">
            <button type="submit" mat-flat-button mat-ripple color="accent">
              <mat-icon>search</mat-icon>
              {{'Commons.Actions.Search' | translate}}
            </button>
            <button mat-icon-button (click)="resetFilter()" matTooltip="{{'Commons.Actions.ResetSearchFilters' | translate}}" matTooltipPosition="above">
              <mat-icon>undo</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!--table-->
  <div class="mat-table-container">

    <!--progress bar-->
    @if (_isLoadingResults) {
      <mat-progress-bar mode="query" color="accent"></mat-progress-bar>
    }

    <mat-table [dataSource]="_tableData" matSort matSortActive="fullName" matSortDirection="asc" matSortDisableClear>

      <!--status-->
      <ng-container matColumnDef="status">
        <mat-header-cell mat-sort-header *matHeaderCellDef class="fw-80 justified-content-center">{{'Modules.Users.Applications.Users.List.Table.Status' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row" class="fw-80 justified-content-center">
          @if (row.status) {
            <i class="material-icons text-green" matTooltip="{{'Commons.Status.Active' | translate}}" matTooltipPosition="above">done</i>
          }
          @if (!row.status) {
            <i class="material-icons text-red" matTooltip="{{'Commons.Status.NotActive' | translate}}" matTooltipPosition="above">close</i>
          }
        </mat-cell>
      </ng-container>

      <!--full name-->
      <ng-container matColumnDef="fullName">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{'Modules.Users.Applications.Users.List.Table.Name' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.name}}</mat-cell>
      </ng-container>

      <!--e-mail-->
      <ng-container matColumnDef="email">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{'Modules.Users.Applications.Users.List.Table.Email' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.email}}</mat-cell>
      </ng-container>

      <!--roles count-->
      <ng-container matColumnDef="rolesCount">
        <mat-header-cell *matHeaderCellDef>{{'Modules.Users.Applications.Users.List.Table.Roles' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.roles}}</mat-cell>
      </ng-container>

      <!--actions-->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="fw-140"></mat-header-cell>
        <mat-cell *matCellDef="let row" class="fw-140 justified-content-end">
          <button mat-icon-button (click)="selectUser(row)" matTooltip="{{'Commons.Actions.Select' | translate}}" matTooltipPosition="above">
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!--definitions-->
      <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>

    </mat-table>
  </div>

  <!--no results-->
  @if (_resultsLength == 0) {
    <div class="mat-table-no-results">
      <span>{{'Commons.Actions.NoResult' | translate}}</span>
    </div>
  }

  <!--paginator-->
  <mat-paginator [length]="_resultsLength" [pageSize]="25" showFirstLastButtons class="sticky left-0"></mat-paginator>

</mat-dialog-content>
